module.exports = __webpack_public_path__ + "static/media/rating-star-clicked.ec7b22b7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/rating-star-clicked.svg
// module id = 643
// module chunks = 0